'use client';

import { useLocale } from 'next-intl';
import { type RefObject, useRef } from 'react';
import { type CountUpProps, useCountUp } from 'react-countup';

import { countDecimals } from '@commons/helpers/number';
import { LOCALES } from '@commons/i18n';

/**
 * Animated number component.
 *
 * Wraps the `react-countup` logic to set the default props.
 *
 * @see https://github.com/glennreyes/react-countup
 *
 * @todo `react-countup` has not yet updated to the new React 19 API, so we need to cast the ref for now.
 */

const AnimatedNumber = ({ start = 0, end, ...props }: CountUpProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const locale = useLocale();

  const decimals = countDecimals(end);

  useCountUp({
    ref: ref as RefObject<HTMLSpanElement>,
    start,
    end,
    decimals,
    separator: locale === LOCALES.FR ? ' ' : ',',
    enableScrollSpy: true,
    scrollSpyOnce: true,
    ...props,
  });

  return (
    <span ref={ref} style={{ whiteSpace: 'nowrap' }}>
      {start}
    </span>
  );
};

export default AnimatedNumber;
